/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Categories_DescriptionInputs */

const en_directory_tools_categories_description = /** @type {(inputs: Directory_Tools_Categories_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore curated categories, groups, and collections.`)
};

const zh_directory_tools_categories_description = /** @type {(inputs: Directory_Tools_Categories_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索精选分类、分组与合集。`)
};

/**
* | output |
* | --- |
* | "Explore curated categories, groups, and collections." |
*
* @param {Directory_Tools_Categories_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_categories_description = /** @type {((inputs?: Directory_Tools_Categories_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Categories_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_categories_description(inputs)
	return zh_directory_tools_categories_description(inputs)
});
export { directory_tools_categories_description as "directory.tools.categories.description" }